export default __webpack_public_path__ + "static/media/cloud-upload.4358f33e.svg";